<template>
  <v-container v-if="meeting" fluid class="pa-0" style="height: 100%">
    <div style="height: 100%">
      <div class="raceGrid mainTable">
        <v-card class="raceGridMidSection">
          <div class="normalModeContainer pl-2">
            <div class="runnerSection">
              <v-skeleton-loader v-if="!hasCompetitors" width="100%" type="article, actions"></v-skeleton-loader>
              <RaceRunnerSection
                v-else
                :race="race"
                :meeting="meeting"
              />
            </div>
          </div>
        </v-card>
      </div>
    </div>
  </v-container>
</template>

<script>
import RaceRunnerSection from './RaceRunnersSection'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'RaceDetail',
  data: () => ({
    showBetslipModal: false,
    showLoginModal: false,
    betslipModalProps: null,
    showAgencyModal: false,
    selectedTime: 'All'
  }),
  props: {
    loginBetting: Function
  },
  components: {
    RaceRunnerSection
  },
  methods: {
    ...mapActions(['updateSortPriceOrder', 'fetchFlucs', 'updateSelectedColumns', 'showFeatureAlert', 'fetchBetTypes', 'setHideBalance']),
    show () {
      this.$modal.show('price-changed-modal')
    },
    hide () {
      this.$modal.hide(
        'price-changed-modal'
      )
    },
    showPA () {
      this.$modal.show('partially-accepted-modal')
    },
    hidePA () {
      this.$modal.hide('partially-accepted-modal')
    },
    showBR () {
      this.$modal.show('bet-rejected-modal')
    },
    hideBR () {
      this.$modal.hide('bet-rejected-modal')
    },
    setSelectedTime (value) {
      this.selectedTime = value
    }
  },
  computed: {
    ...mapGetters([ 'getSelectedMeeting', 'getSelectedRace', 'getRaceCompetitors']),
    ...mapState(['selectedRace']),
    race: function () {
      return this.getSelectedRace()
    },
    meeting: function () {
      return this.getSelectedRace()?.meeting
    },
    balances: function () {
      return this.getBalances
    },
    hasCompetitors () {
      return this.getRaceCompetitors?.length > 0
    },
    extraSpaces: function () {
      return this.race.competitors
    },
    bettingEnabled: function () {
      return !!this.sessionId
    },
    sessionId: function () {
      return this.getSessionId
    }
  }
}
</script>

<style scope>
.normalModeContainer {
  z-index: 1;
  display: flex;
  width: 100%;
  padding:0px;
  background: #fff !important;
  height:100%;
  overflow:hidden;
}
.runnerSection {
  overflow-y:auto;
  width: 100%;
  overflow-x:hidden;
  /* border-right:1px solid #333; */
}
.v-data-table td.priceColumn,
.v-data-table th {
  padding: 0 0px;
}
.v-data-table td {
  padding: 0 0px;
}
thead {
  display: table-header-group;
  vertical-align: bottom;
  border-color: inherit;
}
.table-list {
  display: flex;
}
.v-select.v-text-field--enclosed:not(.v-text-field--single-line):not(.v-text-field--outlined)
  .v-select__selections {
  padding-top: 0px;
}
.v-text-field--filled > .v-input__control > .v-input__slot,
.v-text-field--full-width > .v-input__control > .v-input__slot,
.v-text-field--outlined > .v-input__control > .v-input__slot {
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  min-height: 0;
}
.v-data-table table {
  width: 0;
}
.table-list-item {
  max-width: 150px;
  margin: 0;
  z-index: 200;
}
.raceGrid {
  display: flex;
  flex-direction: column;
  height:inherit;
  font-size:0.8rem;
}
.raceGridMidSection {
  height: 100%;
  overflow:hidden;
}
@keyframes bounce {
  from {
    transform: translateY(0px);
  }
  to {
    transform: translateY(-15px);
  }
}
@-webkit-keyframes bounce {
  from {
    transform: translateY(0px);
  }
  to {
    transform: translateY(-15px);
  }
}
</style>
